import { BillStatus } from '~/types';

const summaryType = ['BILL'];

const getConsolidatedTypeFilter = (transactionTypes, summaryTransactionType) =>
  (transactionTypes || []).filter(
    z => summaryTransactionType.indexOf(z) !== -1
  );

export const mapToServiceFilter = ({
  contextFilter,
  billingTransactionFilter,
  consolidatedTypeFilter,
  isOverdue,
  dueDate,
  billStatus
}) => ({
  projectUri: contextFilter.projectUri,
  clientUris: contextFilter.clientUri
    ? [contextFilter.clientUri]
    : billingTransactionFilter.clients,
  programUri: contextFilter.programUri,
  dateRange: billingTransactionFilter.dateRange,
  searchTerm: billingTransactionFilter.searchTerm,
  transactionTypes: consolidatedTypeFilter,
  balanceStatusList: billStatus ? null : ['UNALLOCATED', 'PARTIALLY_ALLOCATED'],
  isOverdue,
  dueDate,
  billStatus
});

export const getOutstandingQueryParameters = ({
  billingTransactionFilter,
  contextFilter
}) => {
  const consolidatedTypeFilter =
    billingTransactionFilter.transactionTypes &&
    billingTransactionFilter.transactionTypes.length > 0
      ? getConsolidatedTypeFilter(
          billingTransactionFilter.transactionTypes,
          summaryType
        )
      : summaryType;

  return {
    variables: {
      filter: mapToServiceFilter({
        contextFilter,
        billingTransactionFilter,
        consolidatedTypeFilter,
        billStatus: [BillStatus.IssuedPartiallypaid, BillStatus.IssuedUnpaid]
      })
    },
    skip: !consolidatedTypeFilter.length > 0,
    fetchPolicy: 'network-only'
  };
};

export const getDraftQueryParameters = ({
  billingTransactionFilter,
  contextFilter
}) => {
  const consolidatedTypeFilter =
    billingTransactionFilter.transactionTypes &&
    billingTransactionFilter.transactionTypes.length > 0
      ? getConsolidatedTypeFilter(
          billingTransactionFilter.transactionTypes,
          summaryType
        )
      : summaryType;

  return {
    variables: {
      filter: mapToServiceFilter({
        contextFilter,
        billingTransactionFilter,
        consolidatedTypeFilter,
        billStatus: [BillStatus.Draft]
      })
    },
    skip: !consolidatedTypeFilter.length > 0,
    fetchPolicy: 'network-only'
  };
};
